(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[951],{

/***/ 3743:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/convert",
      function () {
        return __webpack_require__(5611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_TopNavigation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4210);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1753);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9618);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1993);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2646);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1902);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1456);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9684);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6834);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5546);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7140);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(3046);
/* harmony import */ var _components_Navigation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5794);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* provided dependency */ var Buffer = __webpack_require__(1876)["Buffer"];







const stringToJson = {
    from: "text",
    to: "json",
    forward: (input)=>JSON.parse(input),
    backward: (input)=>JSON.stringify(input, undefined, 4)
};
const stringToBase64 = {
    from: "text",
    to: "base64",
    forward: (input)=>Buffer.from(input, "utf8").toString("base64"),
    backward: (input)=>Buffer.from(input, "base64").toString("utf8")
};
const stringToReverse = {
    from: "text",
    to: "reverse",
    forward: (input)=>input.split("").reverse().join(""),
    backward: (input)=>input.split("").reverse().join("")
};
const stringToUrlencoded = {
    from: "string",
    to: "urlencoded",
    forward: (input)=>encodeURIComponent(input),
    backward: (input)=>decodeURIComponent(input)
};
var CopyStatus;
(function(CopyStatus) {
    CopyStatus["READY"] = "Copy";
    CopyStatus["COPYING"] = "Copying";
    CopyStatus["COPIED"] = "Copied";
})(CopyStatus || (CopyStatus = {}));
function Breadcrumbs() {
    const breadcrumbItems = [
        {
            text: "Home",
            href: "/"
        },
        {
            text: "Text Converter",
            href: "/convert"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        items: breadcrumbItems,
        expandAriaLabel: "Show path",
        ariaLabel: "Breadcrumbs"
    });
}
var __N_SSP = true;
function Page() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [result, setResult] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [processing, setProcessing] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [from, setFrom] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(typeof router.query["from"] === "string" ? router.query["from"] : "text");
    const [to, setTo] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(typeof router.query["to"] === "string" ? router.query["to"] : "base64");
    const fromTypes = [
        "json",
        "text",
        "urlencoded",
        "base64",
        "reverse"
    ].map((value)=>({
            value,
            __labelPrefix: ""
        }));
    const toTypes = [
        "json",
        "text",
        "urlencoded",
        "base64",
        "reverse"
    ].map((value)=>({
            value,
            __labelPrefix: ""
        }));
    const onSwitchClicked = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(()=>{
        setFrom(to);
        setTo(from);
        setResult(value);
        setValue(result);
    }, [
        to,
        from,
        result,
        value
    ]);
    const runProcess = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((data)=>{
        try {
            let intermediate = "";
            switch(from){
                case "text":
                    intermediate = data;
                    break;
                case "json":
                    intermediate = data;
                    break;
                case "urlencoded":
                    intermediate = stringToUrlencoded.backward(data);
                    break;
                case "base64":
                    intermediate = stringToBase64.backward(data);
                    break;
                case "reverse":
                    intermediate = stringToReverse.backward(data);
                    break;
                default:
                    break;
            }
            switch(to){
                case "urlencoded":
                    setResult(stringToUrlencoded.forward(data));
                    break;
                case "base64":
                    setResult(stringToBase64.forward(intermediate));
                    break;
                case "json":
                    setResult(stringToJson.backward(stringToJson.forward(intermediate)));
                    break;
                case "reverse":
                    setResult(stringToReverse.forward(intermediate));
                    break;
                default:
                    setResult(intermediate);
            }
            setError("");
        } catch (err) {
            if (err instanceof SyntaxError) {
                setError("not JSON: ".concat(err.message));
            } else {
                setError("not base64");
            }
        } finally{
            setProcessing(false);
        }
    }, [
        from,
        to
    ]);
    const setValueDebounce = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.debounce)((data)=>{
        runProcess(data);
    }, 500);
    const [copyStatus, setCopyStatus] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(CopyStatus.READY);
    const onCopyClicked = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((text)=>{
        setCopyStatus(CopyStatus.COPYING);
        navigator.clipboard.writeText(text);
        setTimeout(()=>{
            setCopyStatus(CopyStatus.COPIED);
        }, 200);
        setTimeout(()=>{
            setCopyStatus(CopyStatus.READY);
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TopNavigation__WEBPACK_IMPORTED_MODULE_1__/* .TopNav */ .t, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        variant: "h1",
                        info: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "info",
                            ariaLabel: "Information about text converter."
                        }),
                        children: "Text Converter"
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        size: "m",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                variant: "h1",
                                children: "Text Converter"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    size: "m",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            size: "s",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    size: "s",
                                                    direction: "horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                            variant: "h2",
                                                            children: "Input"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                            enteredTextLabel: (value)=>'Use: "'.concat(value, '"'),
                                                            value: from,
                                                            onChange: (e)=>setFrom(e.detail.value),
                                                            options: fromTypes,
                                                            placeholder: "Enter value",
                                                            empty: "No matches found"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    value: value,
                                                    onChange: (event)=>{
                                                        setProcessing(true);
                                                        setValue(event.detail.value);
                                                        setValueDebounce(event.detail.value);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            size: "s",
                                            direction: "horizontal",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    variant: "primary",
                                                    iconName: "upload",
                                                    onClick: (_)=>runProcess(value),
                                                    loading: processing,
                                                    children: "Convert"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    variant: "normal",
                                                    iconName: "undo",
                                                    onClick: onSwitchClicked,
                                                    children: "Switch"
                                                }),
                                                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    children: error
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            size: "s",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    size: "s",
                                                    direction: "horizontal",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                            variant: "h2",
                                                            children: "Result"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                            enteredTextLabel: (value)=>'Use: "'.concat(value, '"'),
                                                            value: to,
                                                            onChange: (e)=>setTo(e.detail.value),
                                                            options: toTypes,
                                                            placeholder: "Enter value",
                                                            empty: "No matches found"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            iconName: "copy",
                                                            onClick: ()=>onCopyClicked(result),
                                                            loading: copyStatus == CopyStatus.COPYING,
                                                            disabled: copyStatus == CopyStatus.COPIED,
                                                            children: copyStatus
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    readOnly: true,
                                                    value: result
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                headerSelector: "#header",
                breadcrumbs: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Breadcrumbs, {}),
                navigation: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Navigation__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W, {})
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,996,386,990,808,703,834,774,888,179], function() { return __webpack_exec__(3743); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);